// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.isLateDepartureOrReturn {
  background-color: #ffb400 !important;
}
.status-invoiced {
  background-color: #e0e0e0 !important;
}
.status-closed {
  background-color: #a8de91 !important;
}
.isLocked {
  color: #b8b8b8 !important;
}
.isUserDisabled {
  pointer-events: "none";
  opacity: "0.4";
}
.fullCalendarEvent {
  cursor: pointer;
}
.ag-header-cell-text {
  width: "100%";
  color: #55a932;
}
.ag-floating-filter-button {
  color: #55a932;
}
.ag-row-hover {
  background-color: #e6f6e0;
}
.ag-cell-focus {
  border: none !important;
}
/* .ag-theme-grid {
  --ag-row-hover-color: #f0f0f0;
  --ag-font-size: 12px;
} */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* .App {
  text-align: center;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}



.ag-theme-alpine {
  @include ag-theme-alpine();
}


.ag-header {
  font-size: 12px;
  text-align: center;
}




.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
} */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;;GAGG;AACH;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG","sourcesContent":[".App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.isLateDepartureOrReturn {\n  background-color: #ffb400 !important;\n}\n.status-invoiced {\n  background-color: #e0e0e0 !important;\n}\n.status-closed {\n  background-color: #a8de91 !important;\n}\n.isLocked {\n  color: #b8b8b8 !important;\n}\n.isUserDisabled {\n  pointer-events: \"none\";\n  opacity: \"0.4\";\n}\n.fullCalendarEvent {\n  cursor: pointer;\n}\n.ag-header-cell-text {\n  width: \"100%\";\n  color: #55a932;\n}\n.ag-floating-filter-button {\n  color: #55a932;\n}\n.ag-row-hover {\n  background-color: #e6f6e0;\n}\n.ag-cell-focus {\n  border: none !important;\n}\n/* .ag-theme-grid {\n  --ag-row-hover-color: #f0f0f0;\n  --ag-font-size: 12px;\n} */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* .App {\n  text-align: center;\n}\n\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n\n\n.ag-theme-alpine {\n  @include ag-theme-alpine();\n}\n\n\n.ag-header {\n  font-size: 12px;\n  text-align: center;\n}\n\n\n\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
